import React, { Component } from 'react'
import { List } from 'antd'
import { dispatch } from '@@/store';

class DocList extends Component {
  render() {
    const { dataSource, className, listType, onClick } = this.props;
    
    const renderType = {
      FAQ: 'FAQ',
      notices: '公告',
      order: '工单'
    }[listType];

    return (
      <List 
        dataSource={dataSource}
        className={className}
        size="large"
        locale={{emptyText: `暂无该类型${renderType}`}}
        pagination={{
          onChange: page => {
            //
          },
          pageSize: 15
        }}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              key={item.title}
              title={<a>{item.title}</a>}
              onClick={e => onClick(item)}
            />
            <div>{item.date}</div>
          </List.Item>
        )}
      />
    )
  }
}
export default DocList;